import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAutomationExecutionEntity } from './outreach-automation-execution.entity';
import { OutreachAutomationStepEntity } from './outreach-automation-step.entity';
import { OutreachCampaignEntity } from './outreach-campaign.entity';

@Entity('_outreach_automation_flow')
export class OutreachAutomationFlowEntity extends BaseEntity {
	@Column('enum', { name: '_campaign_type', enum: ['email', 'phone'] })
	public campaignType!: 'email' | 'phone';

	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('enum', {
		name: '_trigger_type',
		enum: ['immediate', 'delay', 'behavior'],
	})
	public triggerType!: 'immediate' | 'delay' | 'behavior';

	@Column('json', { name: '_trigger_config', nullable: true })
	public triggerConfig!: object | null;

	@Column('enum', {
		name: '_status',
		enum: ['draft', 'active', 'paused', 'completed'],
	})
	public status!: 'draft' | 'active' | 'paused' | 'completed';

	@Column('tinyint', { name: '_is_active', default: () => "'0'" })
	public isActive!: number;

	@OneToMany(
		() => OutreachAutomationExecutionEntity,
		(outreachAutomationExecution) =>
			outreachAutomationExecution.fkOutreachAutomationFlow,
		{},
	)
	public outreachAutomationExecutions!: Array<OutreachAutomationExecutionEntity>;

	@ManyToOne(
		() => OutreachCampaignEntity,
		(outreachCampaign) => outreachCampaign.outreachAutomationFlows,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_campaign__id', referencedColumnName: 'id' },
	])
	public fkOutreachCampaign!: OutreachCampaignEntity;

	@OneToMany(
		() => OutreachAutomationStepEntity,
		(outreachAutomationStep) => outreachAutomationStep.fkOutreachAutomationFlow,
		{},
	)
	public outreachAutomationSteps!: Array<OutreachAutomationStepEntity>;
}
